<div class="flex flex-col rounded-lg h-full gap-4 mb-1">
  @let executionData = execution();

  <!-- View Button -->
  <div class="flex items-center justify-center w-full">
    @if (executionData.isLive || executionData.url) {
      <div class="flex flex-col items-center justify-center gap-1 w-full">
        @if (executionData.isLive && executionData.url) {
          <button
            mat-flat-button
            color="secondary"
            class="!bg-shikenso-success-light !text-shikenso-success-base hover:!bg-shikenso-success-dark w-full"
            (click)="openSocialUrl(executionData.url)"
          >
            <div class="flex items-center justify-center">
              {{ 'shared.view' | translate }}
            </div>
          </button>
        }

        @if (!executionData.isLive && executionData.url) {
          <button mat-flat-button color="secondary" class="w-full" (click)="openSocialUrl(executionData.url)">
            <div class="!flex items-center justify-center">
              {{ 'shared.view' | translate }}
            </div>
          </button>
        }

        @if (executionData.isLive && executionData.lastProcessed) {
          <div class="flex items-center justify-center text-shikenso-gray-600 text-[10px]">
            {{ executionData.lastProcessed | timeago: true }}
          </div>
        }
      </div>
    }
  </div>

  <!-- Horizontal Divider -->
  @if (kpiCardData().length) {
    <hr class="border-shikenso-purple-base-12" [ngClass]="{ 'max-md:hidden': creatorBriefingMode() }" />
  }

  <!--
    KPI Cards Grid. Mobile briefing sheet: up to 3 equal cards per row, but never narrower than the card's
    min-w-28 (112px), so phones under ~388px fall back to 2 per row; auto-fit lets 1 or 2 cards fill the row.
    Titles wrap instead of being cut off, since a third of a phone is narrower than the desktop title width.
  -->
  <div
    class="grid grid-cols-2 gap-2 w-full"
    [ngClass]="{
      'max-md:grid-cols-[repeat(auto-fit,minmax(max(7rem,calc((100%_-_1rem)/3)),1fr))] max-md:[&_.line-clamp-1]:!line-clamp-none max-md:[&_.line-clamp-1]:!max-w-none':
        creatorBriefingMode(),
    }"
  >
    @let kpiCards = kpiCardData();
    @let isOdd = kpiCards.length % 2 !== 0;

    @if (isOdd && kpiCards.length > 0) {
      <!-- First KPI takes full row if odd -->
      <app-cta-analytics-details-kpi-card
        class="col-span-2"
        [ngClass]="{ 'max-md:col-span-1': creatorBriefingMode() }"
        layout="vertical"
        backgroundColor="var(--shikenso-pink-100-60)"
        titleMaxWidth="229px"
        [data]="kpiCards[0]"
      />

      <!-- Rest are 2 per row -->
      @for (kpiCard of kpiCards.slice(1); track kpiCard.id) {
        <app-cta-analytics-details-kpi-card
          layout="vertical"
          backgroundColor="var(--shikenso-pink-100-60)"
          titleMaxWidth="98px"
          [data]="kpiCard"
        />
      }
    } @else {
      <!-- All rows have 2 cards if even -->
      @for (kpiCard of kpiCards; track kpiCard.id) {
        <app-cta-analytics-details-kpi-card
          layout="vertical"
          backgroundColor="var(--shikenso-pink-100-60)"
          titleMaxWidth="98px"
          [data]="kpiCard"
        />
      }
    }
  </div>
</div>
